import { compose } from 'redux';
import WithSave from './WithSave';
import WithValue from './WithValue';

export default compose(WithValue, WithSave);
